import EN from 'i18n/en/index'

// these will need to be modified when we add more languages
export type TranslationKey = keyof typeof EN // this adds autocomplete for the key names
export type TranslationLanguage = 'en'
export type TranslationTokenMap = Record<string, string | number>

/**
 * Extremely basic translation function
 *
 * Eventually should replace with react-i18next or react-intl
 *
 * @param key The identifier of the translation string to use
 * @param tokens A map of tokens to replace in the translation string
 * @param language The language to use
 */
export function trans(
  key: TranslationKey,
  tokens: TranslationTokenMap = {},
  language: TranslationLanguage = 'en'
) {
  switch (language) {
    case 'en':
    default:
      return EN[key] ? replaceTranslationTokens(EN[key], tokens) : key
  }
}

export function replaceTranslationTokens(
  message: string,
  tokens?: Record<string, string | number>
) {
  if (!tokens) {
    return message
  }

  return message.replace(/{{(\w+)}}/g, (_, token) =>
    String(tokens[token] || '')
  )
}
